import { FileType } from "@/domain/upload/value-objects/FileType";
import {
  ALL_SUPPORTED_EXTENSIONS,
  MEDIA_FILE_EXTENSIONS,
  TEXT_FILE_EXTENSIONS,
  VIDEO_EXTENSIONS,
} from "@/domain/upload/value-objects/SupportedExtensions";
import { FileTypeDetector } from "../ports/FileTypeDetector";

export class ExtensionFileTypeDetector implements FileTypeDetector {
  detect(file: File): FileType {
    const extension = this.getExtension(file);

    if (!extension) {
      return "text";
    }

    // Check video first (video formats take priority)
    if (VIDEO_EXTENSIONS.includes(extension)) {
      return "video";
    }

    // Check text
    if (TEXT_FILE_EXTENSIONS.includes(extension)) {
      return "text";
    }

    // Check audio (media files that aren't video)
    if (MEDIA_FILE_EXTENSIONS.includes(extension)) {
      return "audio";
    }

    return "text";
  }

  isSupported(file: File): boolean {
    const extension = this.getExtension(file);
    return extension ? ALL_SUPPORTED_EXTENSIONS.includes(extension) : false;
  }

  private getExtension(file: File): string | null {
    const extension = file.name.split(".").pop()?.toLowerCase();
    return extension ?? null;
  }
}
